'use es6';

import * as ObjectTypes from 'customer-data-objects/constants/ObjectTypes';
import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';

// HACK: This is a subset of the 63 current default InboundDb associations.
// Expect new default associations to be added. Users can define additional
// types for their portal. Each association's inverse has a different id from
// an overlapping set. See:
// https://git.hubteam.com/HubSpot/InboundDbAssociations/blob/master/InboundDbAssociationsBase/src/main/java/com/hubspot/inbounddb/associations/base/DefaultAssociationType.java
const _associationTypeIds = {
  [`${ObjectTypes.COMPANY}.${ObjectTypes.CONTACT}`]: 2,
  [`${ObjectTypesToIds.COMPANY}.${ObjectTypesToIds.CONTACT}`]: 2,
  [`${ObjectTypes.COMPANY}.${ObjectTypes.DEAL}`]: 6,
  [`${ObjectTypesToIds.COMPANY}.${ObjectTypesToIds.DEAL}`]: 6,
  [`${ObjectTypes.COMPANY}.${ObjectTypes.ENGAGEMENT}`]: 7,
  [`${ObjectTypesToIds.COMPANY}.${ObjectTypesToIds.ENGAGEMENT}`]: 7,
  [`${ObjectTypes.COMPANY}.${ObjectTypes.QUOTE}`]: 72,
  [`${ObjectTypesToIds.COMPANY}.${ObjectTypesToIds.QUOTE}`]: 72,
  [`${ObjectTypes.COMPANY}.${ObjectTypes.TICKET}`]: 25,
  [`${ObjectTypesToIds.COMPANY}.${ObjectTypesToIds.TICKET}`]: 25,
  [`${ObjectTypes.CONTACT}.${ObjectTypes.COMPANY}`]: 1,
  [`${ObjectTypesToIds.CONTACT}.${ObjectTypesToIds.COMPANY}`]: 1,
  [`${ObjectTypes.CONTACT}.${ObjectTypes.DEAL}`]: 4,
  [`${ObjectTypesToIds.CONTACT}.${ObjectTypesToIds.DEAL}`]: 4,
  [`${ObjectTypes.CONTACT}.${ObjectTypes.ENGAGEMENT}`]: 9,
  [`${ObjectTypesToIds.CONTACT}.${ObjectTypesToIds.ENGAGEMENT}`]: 9,
  [`${ObjectTypes.CONTACT}.${ObjectTypes.QUOTE}`]: 70,
  [`${ObjectTypesToIds.CONTACT}.${ObjectTypesToIds.QUOTE}`]: 70,
  [`${ObjectTypes.CONTACT}.${ObjectTypes.TICKET}`]: 15,
  [`${ObjectTypesToIds.CONTACT}.${ObjectTypesToIds.TICKET}`]: 15,
  [`${ObjectTypes.CONTACT}.${ObjectTypes.FEEDBACK_SUBMISSION}`]: 97,
  // [`${ObjectTypesToIds.CONTACT}.${ObjectTypesToIds.FEEDBACK_SUBMISSION}`]: 97, missing objectTypeId for FEEDBACK_SUBMISSION
  [`${ObjectTypes.DEAL}.${ObjectTypes.COMPANY}`]: 5,
  [`${ObjectTypesToIds.DEAL}.${ObjectTypesToIds.COMPANY}`]: 5,
  [`${ObjectTypes.DEAL}.${ObjectTypes.CONTACT}`]: 3,
  [`${ObjectTypesToIds.DEAL}.${ObjectTypesToIds.CONTACT}`]: 3,
  [`${ObjectTypes.DEAL}.${ObjectTypes.ENGAGEMENT}`]: 11,
  [`${ObjectTypesToIds.DEAL}.${ObjectTypesToIds.ENGAGEMENT}`]: 11,
  [`${ObjectTypes.DEAL}.${ObjectTypes.LINE_ITEM}`]: 19,
  [`${ObjectTypesToIds.DEAL}.${ObjectTypesToIds.LINE_ITEM}`]: 19,
  [`${ObjectTypes.DEAL}.${ObjectTypes.PRODUCT}`]: 630,
  [`${ObjectTypesToIds.DEAL}.${ObjectTypesToIds.PRODUCT}`]: 630,
  [`${ObjectTypes.DEAL}.${ObjectTypes.QUOTE}`]: 63,
  [`${ObjectTypesToIds.DEAL}.${ObjectTypesToIds.QUOTE}`]: 63,
  [`${ObjectTypes.DEAL}.${ObjectTypes.TICKET}`]: 27,
  [`${ObjectTypesToIds.DEAL}.${ObjectTypesToIds.TICKET}`]: 27,
  [`${ObjectTypes.ENGAGEMENT}.${ObjectTypes.COMPANY}`]: 8,
  [`${ObjectTypesToIds.ENGAGEMENT}.${ObjectTypesToIds.COMPANY}`]: 8,
  [`${ObjectTypes.ENGAGEMENT}.${ObjectTypes.CONTACT}`]: 10,
  [`${ObjectTypesToIds.ENGAGEMENT}.${ObjectTypesToIds.CONTACT}`]: 10,
  [`${ObjectTypes.ENGAGEMENT}.${ObjectTypes.DEAL}`]: 12,
  [`${ObjectTypesToIds.ENGAGEMENT}.${ObjectTypesToIds.DEAL}`]: 12,
  [`${ObjectTypes.ENGAGEMENT}.${ObjectTypes.QUOTE}`]: 66,
  [`${ObjectTypesToIds.ENGAGEMENT}.${ObjectTypesToIds.QUOTE}`]: 66,
  [`${ObjectTypes.ENGAGEMENT}.${ObjectTypes.TICKET}`]: 18,
  [`${ObjectTypesToIds.ENGAGEMENT}.${ObjectTypesToIds.TICKET}`]: 18,
  [`${ObjectTypes.LINE_ITEM}.${ObjectTypes.DEAL}`]: 20,
  [`${ObjectTypesToIds.LINE_ITEM}.${ObjectTypesToIds.DEAL}`]: 20,
  [`${ObjectTypes.LINE_ITEM}.${ObjectTypes.QUOTE}`]: 68,
  [`${ObjectTypesToIds.LINE_ITEM}.${ObjectTypesToIds.QUOTE}`]: 68,
  [`${ObjectTypes.QUOTE}.${ObjectTypes.COMPANY}`]: 71,
  [`${ObjectTypesToIds.QUOTE}.${ObjectTypesToIds.COMPANY}`]: 71,
  [`${ObjectTypes.QUOTE}.${ObjectTypes.CONTACT}`]: 69,
  [`${ObjectTypesToIds.QUOTE}.${ObjectTypesToIds.CONTACT}`]: 69,
  [`${ObjectTypes.QUOTE}.${ObjectTypes.DEAL}`]: 64,
  [`${ObjectTypesToIds.QUOTE}.${ObjectTypesToIds.DEAL}`]: 64,
  [`${ObjectTypes.QUOTE}.${ObjectTypes.ENGAGEMENT}`]: 65,
  [`${ObjectTypesToIds.QUOTE}.${ObjectTypesToIds.ENGAGEMENT}`]: 65,
  [`${ObjectTypes.QUOTE}.${ObjectTypes.LINE_ITEM}`]: 67,
  [`${ObjectTypesToIds.QUOTE}.${ObjectTypesToIds.LINE_ITEM}`]: 67,
  [`${ObjectTypes.TICKET}.${ObjectTypes.COMPANY}`]: 26,
  [`${ObjectTypesToIds.TICKET}.${ObjectTypesToIds.COMPANY}`]: 26,
  [`${ObjectTypes.TICKET}.${ObjectTypes.CONTACT}`]: 16,
  [`${ObjectTypesToIds.TICKET}.${ObjectTypesToIds.CONTACT}`]: 16,
  [`${ObjectTypes.TICKET}.${ObjectTypes.DEAL}`]: 28,
  [`${ObjectTypesToIds.TICKET}.${ObjectTypesToIds.DEAL}`]: 28,
  [`${ObjectTypes.TICKET}.${ObjectTypes.ENGAGEMENT}`]: 17,
  [`${ObjectTypesToIds.TICKET}.${ObjectTypesToIds.ENGAGEMENT}`]: 17,
  [`${ObjectTypes.TICKET}.${ObjectTypes.FEEDBACK_SUBMISSION}`]: 99,
  // [`${ObjectTypesToIds.TICKET}.${ObjectTypesToIds.FEEDBACK_SUBMISSION}`]: 99, missing objectTypeId for FEEDBACK_SUBMISSION
  [`${ObjectTypes.FEEDBACK_SUBMISSION}.${ObjectTypes.CONTACT}`]: 98,
  // [`${ObjectTypesToIds.FEEDBACK_SUBMISSION}.${ObjectTypesToIds.CONTACT}`]: 98, missing objectTypeId for FEEDBACK_SUBMISSION
  [`${ObjectTypes.FEEDBACK_SUBMISSION}.${ObjectTypes.TICKET}`]: 100
  // [`${ObjectTypesToIds.FEEDBACK_SUBMISSION}.${ObjectTypesToIds.TICKET}`]: 100, missing objectTypeId for FEEDBACK_SUBMISSION
};
export const getAssociationTypeIdByObjectTypeId = (objectTypeFrom, objectTypeTo) => _associationTypeIds[`${objectTypeFrom}.${objectTypeTo}`];